<template>
      <div class="account-page">
    <div class="main-wrapper">
      <layout-header></layout-header>
    <div class="main_home_content">
      <div class="container">
        <div class="row">
          <div class="col-md-10 offset-md-1 pt-5 pb-5">
            <!-- Login Tab Content -->
            <div class="home-content">
              <div class="row align-items-center justify-content-center">
                <div class="col-md-7 col-lg-6">
                  <h2 class="right_heading">
                    Healthcare Appointments, Simplified
                  </h2>
                  <p class="right_content">
                    {{ main_data }} Online Appointment Booking – Connecting
                    Patients and Healthcare Practitioners with Ease
                  </p>
  
                  <div style="margin-top: 50px;">
                    <button class="btn btn-info">Book Appointment</button>
                    <button class="btn btn-success">Department</button>
                  </div>
                </div>
                <div class="col-md-12 col-lg-5">
                  <img
                    src="@/assets/img/doctor_img.png"
                    class="img-fluid"
                    alt="Doccure Login"
                  />
                </div>
              </div>
            </div>
            <!-- /Login Tab Content -->
          </div>
        </div>
      </div>
    </div>
    <layout-footer></layout-footer>
    </div>
    </div>
  </template>
<script>
import config from "../../services/CommonApi";
import axios from "axios";
export default {
  data() {
    return {
      main_data: "",
      config: config,
    };
  },
  mounted() {
    this.get_practitioner_profile();
  },
  methods: {

    async get_practitioner_profile() {
      var domain = window.location.hostname;

      const formdata = {
        domain: window.location.hostname,
      };
      await axios
        .get(
          "https://develop-physio.kneexpert.in/api/method/sahaj.domain.get_hospital?domain=" +
          window.location.hostname
        )
        .then((res) => {
          this.showspinner = false;
          if (res.data.status_code == 200) {
            this.main_data = res.data.data[0].brand_name
          }
          if (res.data.status_code == 404) {
            if (window.location.hostname == "physio.sahajhelp.com") {
            } else if (window.location.hostname == "physio.kneexpert.in") {
            } else if (window.location.hostname == "localhost") {
            }
            else if (window.location.hostname.startsWith("192.168")) {
            } else if (window.location.hostname == "iitb.smartyhealthcare.in") {
            } else {
              window.location.href = String("https://physio.kneexpert.in");
            }
          }
          this.$swal.close();
        });
    },

  },
}
</script>


// WEBPACK FOOTER //
// src/components/kneexpert/OnlineAppointmentBooking.vue